// import powerquery interface
import { GlobalAutoHealing } from "../../components/Interface/IGlobalAutoHealing";


// import action
import {
  ShowApiSuccessAction,
  ClearApiResponseStatusAction,
  ShowApiErrorAction,
  GetReviewContentAction,
  GetReviewContentMarkerAction,
  ApproveReviewContentAction,
  GetReplaceContentAction,
  GetRadioSelectedAction,
  GET_RADIOSELECTED
} from "../Actions/ActionTypes";

// import action types
import {
  SHOW_API_SUCCESS,
  CLEAR_API_RESPONSE_STATUS,
  SHOW_API_ERROR,
  GET_REVIEWCONTENT,
  GET_REVIEWCONTENTMARKER,
  APPROVE_REVIEWCONTENT,
  GET_REPLACECONTENT
} from "../Actions/ActionTypes";

// declare inital state
const initState: GlobalAutoHealing = {
  apiResponseState: {
    StatusCode: '0',
    ErrorMessage: '',
    showErrorDailog: false,
    showSuccessDailog: false
  },
  reviewContent: null,
  reviewContentMarker: null,
  replaceContent: null,
  radioSelected: 'Approve'
};

// contact all actions
type AllActions =
  | ShowApiSuccessAction
  | ClearApiResponseStatusAction
  | ShowApiErrorAction
  | GetReviewContentAction
  | GetReviewContentMarkerAction
  | ApproveReviewContentAction
  | GetReplaceContentAction
  | GetRadioSelectedAction
  
// build power query reducer
export function powerQueryReducer(
  state = initState,
  action: AllActions
): GlobalAutoHealing {
  switch (action.type) {
    case SHOW_API_SUCCESS:
      return {
        ...state,
        apiResponseState: {
          ...state.apiResponseState,
          ErrorMessage: '',
          StatusCode: '0',
          showErrorDailog: false,
          showSuccessDailog: true
        },
      };

    case CLEAR_API_RESPONSE_STATUS:
      return {
        ...state,
        apiResponseState: {
          ...state.apiResponseState,
          //ErrorMessage: '',
          StatusCode: '0',
          showErrorDailog: false,
          showSuccessDailog: false
        },
      };
      case SHOW_API_ERROR:
        return {
          ...state,
          apiResponseState: action.apiResponseState,
        };
    case GET_REVIEWCONTENT:
      return {
        ...state,
        reviewContent: action.reviewContent
      }
    case GET_REVIEWCONTENTMARKER:
      return {
        ...state,
        reviewContentMarker: action.reviewContentMarker
      }
    case GET_REPLACECONTENT:
      return {
        ...state,
        replaceContent: action.replaceContent
      }
    case GET_RADIOSELECTED:
        return {
          ...state,
          radioSelected: action.radioSelected
        }
    case APPROVE_REVIEWCONTENT:
      return state;
    default:
      return state;
  }
}
